import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedChatUser: null
};

const messageCenterSlice = createSlice({
  name: "messageCenter",
  initialState,
  reducers: {
    updateSelectedChatUser: (state, action) => {
      state.selectedChatUser = action.payload;
    }
  },
});

export const {
    updateSelectedChatUser
} = messageCenterSlice.actions;

export default messageCenterSlice.reducer;
